import { useCallback, useEffect } from 'react';
import { Toast } from '@zoom/react-ui';
import './ToastManager.css';

export default function ToastManager({
  toastsData,
  dependencies,
  activeToasts,
  setActiveToasts,
}) {
  const ToastBottom = Toast.create({ placement: 'bottom' });

  const toastToggle = useCallback(() => {
    const activeToastData = toastsData.filter(({ condition }) => condition);
    activeToastData.forEach(
      ({
        toastId,
        type,
        condition,
        className,
        content,
        closable,
        duration,
        onClose,
      }) => {
        if (condition) {
          ToastBottom[type]({
            className: className,
            content: content,
            closable: closable,
            duration: duration,
            onClose: () => {
              setActiveToasts((prevToasts) =>
                prevToasts.filter((toast) => toast !== toastId)
              );
              if (onClose) onClose();
            },
          });
          setActiveToasts((prevToasts) => [...prevToasts, toastId]);
          if (toastId === 'timesUp') {
            setTimeout(() => {
              removeToastStyling();
            }, 5000);
          }
        }
      }
    );
  }, [dependencies]);

  useEffect(() => {
    toastToggle();
  }, []);

  useEffect(() => {
    return () => {
      killActiveToasts({ activeToasts, setActiveToasts });
    };
  }, []);

  return null;
}

export function killActiveToasts({ activeToasts, setActiveToasts }) {
  const toastLists = document.querySelectorAll("div[class^='ui-Toast-list']");
  toastLists.forEach((toastList) => {
    const toastError = toastList?.querySelector('.toast-video-error');
    if (toastError) {
      const parentElement = toastList.parentElement;
      if (parentElement) {
        parentElement.remove();
      }
    }
  });
  const toastTypes = [
    'turnOnVideo',
    'turnOnVideoAndTurnOffMirror',
    'setMirrorMyVideoOff',
    'activeTimerRunningError',
  ];
  if (toastTypes.some((toast) => activeToasts.includes(toast))) {
    setActiveToasts((prevToasts) =>
      prevToasts.filter(
        (toast) =>
          toast !== 'turnOnVideo' &&
          toast !== 'turnOnVideoAndTurnOffMirror' &&
          toast !== 'setMirrorMyVideoOff' &&
          toast !== 'activeTimerRunningError'
      )
    );
  }
}

export function removeToastStyling() {
  const toastLists = document.querySelectorAll("div[class^='ui-Toast-list']");
  toastLists.forEach((toastList) => {
    if (toastList.children.length > 0) {
      toastList.style.bottom = '';
    }
  });
}

export function alignToasts({ activeToasts }) {
  if (activeToasts.length > 1) {
    const toastLists = document.querySelectorAll("div[class^='ui-Toast-list']");
    let currentBottom = 40;

    for (let i = toastLists.length - 1; i >= 0; i--) {
      const toastList = toastLists[i];
      const videoError = toastList?.querySelector('.toast-video-error');
      const timesUp = toastList?.querySelector('.toast-times-up');

      if (i === toastLists.length - 1) {
        if (videoError) currentBottom += 93;
        if (timesUp) currentBottom += 73;
      } else {
        if (videoError) {
          toastList.style.setProperty(
            'bottom',
            `${currentBottom}px`,
            'important'
          );
          currentBottom += 93;
        } else if (timesUp) {
          toastList.style.setProperty(
            'bottom',
            `${currentBottom}px`,
            'important'
          );
          currentBottom += 73;
        }
      }
    }
  } else if (activeToasts.length === 1) {
    removeToastStyling();
  }
}
